import {z} from "zod";

const schema = z.object({
	year: z.string(),
	firstHalf: z.boolean(),
	sumOfActualAmount: z.number()
});

const model = schema.transform((values) => ({
	...values
}));

export const HalfYearModel = {schema, model};
export type IHalfYearModel = z.infer<typeof HalfYearModel.model>;
export const DEFAULT_HALF_YEAR: IHalfYearModel = {
	year: "",
	firstHalf: false,
	sumOfActualAmount: 0
};
